<ngx-spinner size="medium" type="line-spin-fade"></ngx-spinner>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<p-confirmDialog acceptLabel="Aceptar" rejectLabel="Cancelar" [style]="{width: '425px'}" appendTo="body"
rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<p-toast appendTo="body" [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'1000ms'" [hideTransitionOptions]="'1000ms'" [showTransformOptions]="'translateX(100%)'"></p-toast>

<router-outlet></router-outlet>